import { chakra } from '@chakra-ui/react';

export const Small = chakra('small', {
  baseStyle: {},
});

export const H1 = chakra('h1', {
  baseStyle: {
    fontSize: '28px',
    fontWeight: '600',
    lineHeight: '34px',
  },
});

export const H2 = chakra('h2', {
  baseStyle: {
    fontSize: '18px',
    fontWeight: '600',
    lineHeight: '24px',
  },
});

export const H3 = chakra('h3', {
  baseStyle: {
    textTransform: 'uppercase',
    fontSize: 'sm',
    fontWeight: 'bold',
  },
});

export const Form = chakra('form', {
  baseStyle: {},
});

export const Span = chakra('span', {
  baseStyle: {},
});

export const Div = chakra('div', {
  baseStyle: {},
});

export const Strong = chakra('strong', {
  baseStyle: {},
});
